module.exports = __webpack_public_path__ + "static/media/mail-sent.15bf3778.svg";